import ArrowRightCircleSVG from "../../../assets/icons/arrow-right-circle.svg"
export const ArrowRightCircle: React.FC = () => {
  return (
    <img src={ArrowRightCircleSVG} alt="" className="w-[20px] h-[20px] cursor-pointer" />
  )
}
